import { createFileRoute } from "@tanstack/react-router";
import { HostingSalesPage } from "@/components/site/hosting-sales-page";
import { getHostingPageMeta } from "@/lib/hosting-public.functions";

const SLUG = "hosting/web";
const CANONICAL = "/hosting/web";
const FALLBACK_TITLE = "Web Hosting — Fast, Secure NVMe Hosting";
const FALLBACK_DESC = "Blazing-fast web hosting on NVMe SSD + LiteSpeed with free SSL, daily backups, free migration and a 99.99% uptime SLA.";

export const Route = createFileRoute("/hosting/web/")({
  component: WebHostingIndex,
  loader: () => getHostingPageMeta({ data: { slug: SLUG } }).catch(() => null),
  head: ({ loaderData }) => {
    const meta = loaderData ?? null;
    const title = meta?.seo_title || meta?.title || FALLBACK_TITLE;
    const desc = meta?.seo_description || meta?.subtitle || FALLBACK_DESC;
    const image = meta?.og_image_url || meta?.hero_image_url || undefined;
    const tags: Array<Record<string, string>> = [
      { title },
      { name: "description", content: desc },
      { property: "og:title", content: title },
      { property: "og:description", content: desc },
      { property: "og:type", content: "website" },
      { property: "og:url", content: CANONICAL },
      { name: "twitter:card", content: image ? "summary_large_image" : "summary" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: desc },
    ];
    if (image) {
      tags.push({ property: "og:image", content: image });
      tags.push({ name: "twitter:image", content: image });
    }
    return { meta: tags, links: [{ rel: "canonical", href: CANONICAL }] };
  },
});

function WebHostingIndex() {
  return <HostingSalesPage slug={SLUG} />;
}
